import React, { useState, useRef, useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Button, Modal, Progress, Spin, Upload, ConfigProvider, Select } from "antd";
import usePreventDragAndDrop from "../../Hooks/usePreventDragAndDrop";
import { FaCloudUploadAlt } from "react-icons/fa";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  GetPartnerBankDetailsById,
  SubmitPartnerBankDetails,
} from "../../../Api/UserManagement/Partner";
import axios from "axios";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";

const FILE_SIZE = 1024 * 1024 * 5; // 5MB
const SUPPORTED_FORMATS = [
  "application/pdf",
  "image/jpg",
  "image/jpeg",
  "image/png",
];
const validationSchema = Yup.object().shape({
  acc_holder_name: Yup.string()
    .required("Account holder name is required")
    .min(3, "At least 3 characters long")
    .max(30, "Maximum 20 characters only")
    .matches(/^[A-Za-z\s]+$/, "Account Holder name must include only alphabets"),
  acc_num: Yup.string()
  .required("Account number is required")
  .matches(/^\d+$/, "Account number must contain only digits")
  .min(9, "Account number must be at least 9 digits")
  .max(18, "Account number cannot exceed 18 digits"),
  bank_name: Yup.string()
    .required("Bank name is required")
    .matches(/^[A-Za-z\s]+$/, "Bank name must include only alphabets"),
  
IFSC_code: Yup.string()
  .required("IFSC code is required")
  .length(11, "Must be 11 characters")
  .test(
    "fifth-char-zero",
    "5th character must be 0",
    value => value && value[4] === "0"
  )

    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "IFSC must be in format ABCD0000000"),
  branch_name: Yup.string()
    .required("Branch name is required")
    .matches(/^[A-Za-z\s]+$/, "Branch name must include only alphabets"),
  city: Yup.string()
    .required("City is required")
    .min(3, "At least 3 characters long")
    .max(25, "Maximum 20 characters only"),
UPI_Id: Yup.string()
  .matches(
    /^[a-zA-Z0-9._-]+@[a-zA-Z]{3,24}$/,
    "Invalid UPI ID format"
  )
  .max(45, "UPI ID cannot exceed 45 characters"),


  passbook_doc: Yup.mixed()
    .required("Passbook doc is required")
    .test("fileSize", "File too large max 5mb", (value) =>
      typeof value === "string" ? true : value && value.size <= FILE_SIZE
    )
    .test("fileFormat", "Unsupported Format", (value) =>
      typeof value === "string"
        ? true
        : value && SUPPORTED_FORMATS.includes(value.type)
    ),
});

const AddBankDetails = ({
  setCurrentpage,
  currentpage,
  PartnerID,
  setPartnerID,
  setDocumentBack,
  setModalIsOpen,
  updatedata,
}) => {
  console.log(updatedata, "uuuuuudata");
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const [enable, setEnable] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [partnerBankDetails, setPartnerBankDetails] = useState({
    acc_holder_name: "",
    acc_num: "",
    bank_name: "",
    IFSC_code: "",
    branch_name: "",
    city: "",
    UPI_Id: "",
    passbook_doc: null,
  });
  const [inputPreview, setInputPreview] = useState({
    passbook_doc: null,
  });
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);

  usePreventDragAndDrop(inputRef1);
  usePreventDragAndDrop(inputRef2);
  usePreventDragAndDrop(inputRef3);
  usePreventDragAndDrop(inputRef4);
  usePreventDragAndDrop(inputRef5);

        const handleKeyDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault(); // Block all other characters
    }
  };

  const handleFileChange = (event, key) => {
    const file = event?.currentTarget?.files[0];

    // Check if the file is selected and it's a valid file
    if (file) {
      // Validate if the selected file is an actual file object
      if (file instanceof File) {
        setInputPreview((prevState) => ({
          ...prevState,
          [key]: URL.createObjectURL(file), // Create object URL for valid file
        }));
      } else {
        console.error("Selected item is not a valid file.");
      }
    } else {
      console.error("No file selected.");
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const openModal = (event) => {
    // Get the image source (src) using `getElementById`
    const imageSrc = event.target.getAttribute("src");

    // Set the modal image source
    setModalImage(imageSrc);

    // Open the modal
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const dispatch = useDispatch();
  const handleSubmit = async (values) => {
    console.log(values, "docvalues");
    // if (updatedata) {
    //   toast.success("Partner Updated Successfully");
    // }

    try {
      if (
        enable === false &&
        updatedata &&
        partnerBankDetails?.acc_holder_name != null
      ) {
        setModalIsOpen(false); // Assuming setCurrentPage is a function in your component
      } else {
        const data = await SubmitPartnerBankDetails(
          values,
          updatedata,
          dispatch
        ); // Replace with actual API call function
        // toast.success(data);
        setModalIsOpen(false);
        // Assuming setCurrentPage is a function in your component
        // console.log(values,actions,"docvalues");
      }
    } catch (error) {
      console.error("Error uploading data", error);
      toast.error("Failed to submit document. Please try again."); // Notify user of error
    } finally {
      // actions.setSubmitting(false);
    }
  };

  const fetchGetUser = async () => {
    try {
      const data = await GetPartnerBankDetailsById(
        PartnerID,
        setPartnerID,
        setPartnerBankDetails,
        updatedata,
        setSpinning
      );
      setPartnerBankDetails(data[0]);
      console.log(data[0], "setPartnerBankDetails");
    } catch (error) {
      console.error("Error fetching additional user data", error);
    }
  };

  useEffect(() => {
    if (updatedata != null) {
      fetchGetUser();
      setSpinning(true);
    }
  }, [PartnerID, setPartnerID, setPartnerBankDetails, updatedata]);

  useEffect(() => {
    setInputPreview({
      passbook_doc: partnerBankDetails?.passbook_doc,
    });
  }, [partnerBankDetails]);

  const stationUrl = process.env.REACT_APP_API_WEB_URL
  const[cities,setCities] = useState([])
  const [selectedCity, setSelectedCity] = useState('');
  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${stationUrl}/getStation/$`);
        const cityOptions = response.data.map(city => ({
          value: city.station_name,
          label: (
            <div className="text-[1vw] font-normal px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
              {city.station_name}
            </div>
          ),
          state: city.state_name
        }));
        setCities(cityOptions);
        console.log(cityOptions,"cities api")
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchCities();
  }, []);

  const fetchAllCities = async (searchText) => {
    try {
      const response = await axios.get(searchText?`${stationUrl}/getStation/${searchText}`:`${stationUrl}/getStation/$`);
      const cityOptions = response.data.map(city => ({
        value: city.station_name,
        label: (
          <div className="text-[1vw] font-normal px-[0.2vw] pb-[0.1vw] text-[#1F487C]">
            {city.station_name}
          </div>
        ),
        state: city.state_name
      }));
      setCities(cityOptions);
      console.log(response, "all cities")
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const handleCityChange = (value, setFieldValue) => {
    setSelectedCity(value);
    const selectedCityData = cities.find(city => city.value === value);
    if (selectedCityData) {
      // setStates(selectedCityData.state);
      setFieldValue('temp_state', selectedCityData.state);
    }
  };

  const handleInput = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Remove special characters and numbers
};

  return (
    <div>
      <div className="border-l-[0.1vw] relative  px-[2vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] rounded-[1vw] border-[#1f4b7f] mt-[1.5vw]">
        <div className="h-[4vw] w-full flex items-center justify-between ">
          <label className="text-[1.5vw] font-semibold text-[#1f4b7f] ">
            Bank Details
          </label>
          {updatedata ? (
            <button
              className={`${
                enable
                  ? "bg-[#1f4b7f] text-white"
                  : "text-[#1f4b7f] bg-white border-[#1f4b7f]"
              } rounded-full font-semibold w-[10vw] h-[2vw] flex items-center justify-center border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] border-r-[0.1vw] text-[1.1vw] `}
              onClick={() => {
                setEnable(!enable);
              }}
            >
              Enable to Edit
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="pb-[1vw]">
          <div className="border-b-[0.1vw] w-full border-[#1f4b7f]"></div>
        </div>
        <Formik
          initialValues={{
            acc_holder_name: partnerBankDetails?.acc_holder_name || "",
            acc_num: partnerBankDetails?.acc_num || "",
            bank_name: partnerBankDetails?.bank_name || "",
            IFSC_code: partnerBankDetails?.IFSC_code || "",
            branch_name: partnerBankDetails?.branch_name || "",
            city: partnerBankDetails?.city || "",
            UPI_Id: partnerBankDetails?.UPI_Id || "",
            passbook_doc: partnerBankDetails?.passbook_doc || "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isSubmitting, isValid, setFieldValue, values, handleChange }) => (
            <Form>
              {spinning ? (
                <div className=" flex justify-center h-[23.2vw] items-center">
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  <div className="gap-y-[1.5vw] flex-col flex h-[18vw] overflow-y-scroll pr-[.5vw] pb-[1vw]">
                    {/* c1 */}
                    <div className="grid grid-cols-2 w-full gap-x-[2vw]">
                      {/* c1-1 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          Account Holder Name
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <Field
                          type="text"
                          name="acc_holder_name"
                          autoComplete="off"
                          placeholder="Enter Account Holder Name"
                          innerRef={inputRef1}
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
                          }}
                          value={values.acc_holder_name}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        <ErrorMessage
                          name="acc_holder_name"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                      {/* c1-2 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          Account Number
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <Field
                          type="text"
                          name="acc_num"
                          autoComplete="off"
                          placeholder="Enter Account Number"
                          innerRef={inputRef2}
                          value={values.acc_num}
                          onKeyDown={handleKeyDown}
                          onChange={(e) => {
                  let inputValue = e.target.value;
                  inputValue = inputValue.replace(/\s+/g, "");
                handleChange({
                  target: { name: e.target.name, value: inputValue },
                });
}}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        {console.log(updatedata,partnerBankDetails?.acc_holder_name,enable,"chchchchchchc")}
                        <ErrorMessage
                          name="acc_num"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                    </div>
                    {/* c2 */}
                    <div className="grid grid-cols-2 w-full gap-x-[2vw] ">
                      {/* c1-1 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          Bank Name
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <Field
                          type="text"
                          name="bank_name"
                          autoComplete="off"
                          placeholder="Enter Bank Name"
                          innerRef={inputRef1}
                          value={values.bank_name}
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
                          }}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        <ErrorMessage
                          name="bank_name"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                      {/* c1-2 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          IFSC Code
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <Field
                          type="text"
                          name="IFSC_code"
                          autoComplete="off"
                          placeholder="Enter IFSC Code"
                          innerRef={inputRef2}
                          value={values.IFSC_code}
                          onChange={(e) =>
                          {
                          let inputValue = e.target.value;
                          inputValue = inputValue.replace(/\s+/g, "");
                          handleChange({
                              target: { name: e.target.name, value: inputValue },
                            })
                          setFieldValue("IFSC_code",inputValue?.toUpperCase())
                          }}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        <ErrorMessage
                          name="IFSC_code"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                    </div>
                    {/* c3 */}
                    <div className="grid grid-cols-2 w-full gap-x-[2vw]">
                      {/* c1-1 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          Branch Name
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <Field
                          type="text"
                          name="branch_name"
                          autoComplete="off"
                          placeholder="Enter Branch Name"
                          innerRef={inputRef1}
                          value={values.branch_name}
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
                          handleChange({
                           target: { name: e.target.name, value: cleanedValue },
                            });
                          }}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        <ErrorMessage
                          name="branch_name"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                      {/* c1-2 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          City
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                        </label>
                        <ConfigProvider
                        theme={{
                          components: {
                            Select: {
                              optionActiveBg: '#aebed1',
                              optionSelectedColor: '#FFF',
                              optionSelectedBg: '#e5e5e5',
                              optionHeight: '2',
                            },
                          },
                        }}
                      >
                        <Select
                          showSearch
                          // value={values.temp_city}
                          value={values.city || undefined}
                          placement="topRight"
                          listHeight={190}
                          innerRef={inputRef2}
                          onChange={(value) => {
                            handleChange({ target: { name: 'city', value } })
                            handleCityChange(value, setFieldValue)
                          }}
                          onSearch={fetchAllCities}
                          onInput={handleInput}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          name="city"
                          className={`${updatedata && partnerBankDetails?.acc_holder_name != null
                            ? enable == false
                              ? " cursor-not-allowed bg-[#FAFAFA]"
                              : ""
                            : ""
                            } custom-select bg-white border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw]`}
                          // className="custom-select bg-white outline-none w-full mt-[0.5vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-xl border-r-[0.2vw] border-b-[0.2vw] placeholder-[#1F487C]"
                          placeholder="Select City"
                          filterOption={(input, option) => 
                            option?.value?.toLowerCase()?.includes(input.toLowerCase()) // Make it case-insensitive
                          }
                          optionFilterProp="value"
                          suffixIcon={<span style={{ fontSize: '1vw', color: '#1f487c' }}>
                               <IoMdArrowDropup size="2vw" />
                          </span>}
                          style={{ padding: 4 }}
                          options={cities}    
                        />
                      </ConfigProvider>
                        <ErrorMessage
                          name="city"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                    </div>
                    {/* c4 */}
                    <div className="grid grid-cols-2 w-full gap-x-[2vw]">
                      {/* c1-1 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          UPI Id
                        </label>
                        <Field
                          type="text"
                          name="UPI_Id"
                          autoComplete="off"
                          placeholder="Enter UPI Id"
                          innerRef={inputRef1}
                          value={values.UPI_Id}
                          disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          className={`${
                            updatedata || partnerBankDetails?.acc_holder_name
                              ? enable == false
                                ? " cursor-not-allowed"
                                : ""
                              : ""
                          } border-r-[0.3vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder:font-sans`}
                        />
                        <ErrorMessage
                          name="UPI_Id"
                          component="div"
                          className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                        />
                      </div>
                      {/* c1-2 */}
                      <div className="col-span-1 relative">
                        <label className="text-[#1F4B7F] text-[1.1vw] ">
                          Passbook Doc
                          <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                            *
                          </span>
                          <span className="text-[#909193] text-[0.7vw] font-bold pl-[0.25vw]">
                {`(Max Size:5MB)`}
              </span>
                        </label>
                        <div>
                          <input
                            id="passbook_doc"
                            name="passbook_doc"
                            accept=".jpg, .jpeg, .png"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(event) => {
                              const files = Array.from(event.target.files);
                              console.log(files, "filesfiles");
                              setFieldValue(
                                "passbook_doc",
                                event.currentTarget.files[0]
                              );
                              // handlePreview(files[0]);
                              handleFileChange(event, "passbook_doc");
                            }}
                            disabled={
                            updatedata ||
                            partnerBankDetails?.acc_holder_name != null
                              ? enable
                                ? false
                                : true
                              : false
                          }
                          />
                          <div className="relative">
                            <button
                              type="button"
                              className={` ${
                                updatedata &&
                                partnerBankDetails?.acc_holder_name != null
                                  ? enable == false
                                    ? " cursor-not-allowed"
                                    : ""
                                  : ""
                              } border-r-[0.3vw]  flex items-center justify-between px-[1vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-[100%] rounded-[0.5vw] outline-none`}
                              onClick={(event) => {
                                event.preventDefault();
                                document.getElementById("passbook_doc").click();
                              }}
                            >
                              <span className="text-[1vw] font-sans text-[#9ba6bbe3]">
                                Upload Passbook Doc
                              </span>
                            </button>
                            {inputPreview?.passbook_doc ? (
                              inputPreview?.passbook_doc?.startsWith("blob") ? (
                                <img
                                  src={inputPreview.passbook_doc}
                                  className="h-[2.5vw] w-[2.5vw] absolute top-[.15vw] cursor-zoom-in right-[.3vw]"
                                  alt="Aadhar Front"
                                  onClick={openModal}
                                />
                              ) : (
                                <img
                                  src={`${apiImgUrl}${inputPreview.passbook_doc}`}
                                  className="h-[2.5vw] w-[2.5vw] absolute  top-[.15vw] cursor-zoom-in right-[.3vw]"
                                  alt="Aadhar Front"
                                  onClick={openModal}
                                />
                              )
                            ) : (
                              <FaCloudUploadAlt
                                color="#1F487C"
                                size="2vw"
                                className="absolute right-[1vw] top-[.4vw] pointer-events-none"
                              />
                            )}
                          </div>
                          <ErrorMessage
                            name="passbook_doc"
                            component="div"
                            className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw] left-[.3vw]"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center  w-full justify-between pb-[1vw] pt-[2vw]">
                    <div>
                      <h1 className="text-[#1F4B7F] text-[0.7vw] font-semibold">
                        *You must fill in all fields to be able to continue
                      </h1>
                    </div>
                    <div className="flex items-center gap-x-[1vw]">
                      <button
                        className="border-[#1F487C] w-[5vw] font-semibold text-[1vw] h-[2vw] rounded-full border-r-[0.2vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.2vw]"
                        onClick={() => {
                          setCurrentpage(3);
                          setDocumentBack(true);
                        }}
                      >
                        Back
                      </button>
                      <button
                        className="bg-[#1F487C] font-semibold rounded-full w-[10vw] h-[2vw] text-[1vw] text-white"
                        type="submit"
                        // onClick={() => setCurrentpage(4)}
                        // onClick={()=>{
                        //   if(updatedata){
                        //     toast.success("Partner Updated Successfully")
                        //   }
                        //   else{
                        //     toast.success("Partner Submitted Successfully")
                        //   }
                        // }}
                      >
                        {updatedata &&
                        partnerBankDetails?.acc_holder_name != null
                          ? enable
                            ? "Update & Submit"
                            : "Submit"
                          : "Submit"}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </Form>
          )}
        </Formik>
      </div>

      <Modal
        visible={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        // width="35vw"
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true} // Ensures modal is destroyed on close
        closable={false} // Removes the close button at the top right
      >
        {/* Display the image in the modal */}
        {modalImage && (
          <img
            src={modalImage}
            alt="Document Preview"
            style={{ width: "100%" }}
            className=""
          />
        )}
      </Modal>
    </div>
  );
};

export default AddBankDetails;
